<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-auto_fetch'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('new')} ${$t('auto_fetch')}`"
    @add_click="onAddAutoFetch"
  >
    <!-- :addLinkLabel="
      `${$t('add')} ${$t('new')} ${$dft.capHead(channel)} ${$t('group')}`
    " -->
    <!-- :rightMenu="[
      {
        text: this.$t('auto_fetch_label_supplier'),
        value: 'auto_fetch_label_supplier'
      }
    ]"
    @menuClick="onRightMenuClick" -->
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-auto_fetch-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedContractDetails.relations || []"
      :showNoItems="false"
    >
    
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('auto_fetch')">
            <span class="txtov" :title="item['external_table2']">
              {{ item["external_table2"] }}
            </span>
          </td>
          <td v-bind="tdcon('label_name')">
            <span
              class="txtov"
              :title="
                item['label_name'] ? item['label_name'] : item['supplier_name']
              "
            >
              {{
                item["label_name"] ? item["label_name"] : item["supplier_name"]
              }}
            </span>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteLicencing(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedContractDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("auto_fetch", { f: 0.6, text: "Auto Fetch" }),
        createTableHeader("label_name", { text: "Label / Supplier" }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    }
  },
  methods: {
    onAddAutoFetch: function() {
      this.$emit("add_click", true);
    },

    onDeleteLicencing: async function(item) {
      const confirmationResult = await confirmDelete(
        "name",
        item.external_table2
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
    // onRightMenuClick: function(menu) {
    //   if (menu == "auto_fetch_label_supplier") {
    //     this.$emit("auto_fetch_label_supplier", true);
    //   }
    // }
  }
};
</script>
